import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core'
import {HttpClientModule} from '@angular/common/http'
import {CoreModule} from './@core/core.module'
import {ThemeModule} from './@theme/theme.module'
import {AppComponent} from './app.component'
import {AppRoutingModule} from './app-routing.module'
import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme'
import {I18nService} from './@core/translate/i18n.service'
import {HttpService} from './@core/http/http.service'
import {Observable, of} from 'rxjs'
import {TranslateLoader, TranslateModule} from '@ngx-translate/core'
import 'app/utils/array.util'
import {CommonModule, registerLocaleData} from '@angular/common'
import {AuthModule} from './auth/auth.module'
import {NbDateFnsDateModule} from '@nebular/date-fns'
import {cs as _cs} from 'date-fns/esm/locale'
// registerLocale('es', _cs)

import localeCS from '@angular/common/locales/cs'
registerLocaleData(localeCS)

// @ts-ignore
import cs from '../assets/i18n/cs.json'
import {AuthService} from './auth/auth.service';

export class LanguageLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    return of(cs)
  }
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: LanguageLoader
      }
    }),
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    AuthModule,
    NbDateFnsDateModule.forRoot({format: 'dd.MM.yyyy', parseOptions: {locale: _cs}, formatOptions: {locale: _cs}}),
    NbDateFnsDateModule.forChild({format: 'dd.MM.yyyy', parseOptions: {locale: _cs}, formatOptions: {locale: _cs}}),
  ],
  bootstrap: [AppComponent],
  providers: [
    HttpService,
    I18nService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [HttpService, AuthService]
    },
    {provide: LOCALE_ID, useValue: 'cs-CZ'}
  ]
})
export class AppModule {
}

export function appInitializer(
  httpService: HttpService,
  authService: AuthService,
): () => Promise<any> {
  return async (): Promise<any> => {
    const [me, core] = await Promise.all([
      authService.fetchMe(),
    ])
    return [me, core]
  }
}

